import {
    Box,
    Button,
    TextField,
} from "@mui/material";
import { ChatMessage } from "../../common/models";
import { useRef, useEffect, useState } from "react";

interface Props {
    message: ChatMessage
    cancelUpdate: () => void
    sendMessage: (message: ChatMessage) => void
}

const MuiDraftMessage = ({ message, cancelUpdate, sendMessage }: Props) => {
    const chatMessageStreamEnd = useRef<HTMLDivElement>(null);
    const textFieldRef = useRef<HTMLInputElement | null>(null);
    const [messageContent, setMessageContent] = useState<string>(message.content);

    // Scroll to the draft message
    useEffect(() => {
        if (chatMessageStreamEnd.current) {
            chatMessageStreamEnd.current.scrollIntoView({
                behavior: "smooth",
                block: "end",
            });
        }
    }, [message]);

    // Focus and move the cursor to the end of the text
    useEffect(() => {
        if (textFieldRef.current) {
            const input = textFieldRef.current;
            input.focus();
            input.setSelectionRange(input.value.length, input.value.length); // Move cursor to the end
        }
    }, []);

    const updateMessage = () => {
        const updatedMessage: ChatMessage = {
            ...message,
            content: messageContent,
        };

        sendMessage(updatedMessage);
    }

    return (
        <Box
            ref={chatMessageStreamEnd}
            key={message.messageId}
            sx={{
                width: "100%",
                bgcolor: "#4e628e",
                borderRadius: 3,
                mb: 2,
            }}
        >
            <Box sx={{ p: 3 }}>
                <TextField
                    variant="outlined"
                    fullWidth
                    inputRef={textFieldRef} // Attach the ref to the TextField
                    value={messageContent}
                    onChange={(e) => setMessageContent(e.target.value)}
                    multiline
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            color: "#e1e6f0",
                            padding: 0,
                            fontSize: 14,
                            border: 'none',

                            // modify fieldset
                            "& fieldset": {
                                border: "none",
                            },
                        },
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                            e.preventDefault(); // Prevents new line on Enter key
                            updateMessage(); // Call the update message function
                        }
                    }}
                />
            </Box>
            <Box
                sx={{ p: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}
            >
                <Button
                    variant="contained"
                    sx={{
                        bgcolor: "#3d6190",
                        color: "white",
                        "&:hover": { bgcolor: "#345580" },
                    }}
                    onClick={cancelUpdate}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    // color="button"
                    sx={{
                        color: 'button'
                    }}
                    onClick={updateMessage}
                >
                    Send
                </Button>
            </Box>
        </Box>

    )
};

export default MuiDraftMessage;
